import React, { FC } from 'react'

import { Brand } from '@Generated/graphql'

import styles from './BrandOverlay.module.scss'

interface Props {
  brand?: Brand
  children?: React.ReactNode
}

export const BrandOverlay: FC<Props> = ({ brand, children }) => (
  <div className={styles.styledBrand}>
    {children}
    {brand?.logo && (
      <div className={styles.styledOverlay}>
        <div className={styles.styledImage}>
          <img
            alt={brand.title || ''}
            loading="lazy"
            src={brand.logo}
          />
        </div>
      </div>
    )}
  </div>
)
